// ABOUTME: Displays uncovered Branches after a pre-registration save is rejected.
// ABOUTME: Keeps coverage guidance separate from configuration state and actions.
import React from "react";

import { WhatsappPreRegistrationLabels } from "./whatsappPreRegistrationLabels";
import { WhatsappPreRegistrationCoverageDiagnostic } from "./useWhatsappPreRegistrationCoverageDiagnostic";

interface WhatsappPreRegistrationCoverageDiagnosticAlertProps {
    coverageDiagnostic: WhatsappPreRegistrationCoverageDiagnostic;
    labels: Pick<
        WhatsappPreRegistrationLabels,
        | "coverageBranchesTitle"
        | "coverageBranchesHelp"
        | "coverageBranchesRemaining"
    >;
}

const WhatsappPreRegistrationCoverageDiagnosticAlert = ({
    coverageDiagnostic,
    labels
}: WhatsappPreRegistrationCoverageDiagnosticAlertProps) => (
    <>
        <strong>{labels.coverageBranchesTitle}</strong>
        <p>{labels.coverageBranchesHelp}</p>
        <ul>
            {coverageDiagnostic.uncoveredBranches.map(branch => (
                <li key={branch.id}>{branch.name}</li>
            ))}
        </ul>
        {coverageDiagnostic.uncoveredBranchCount >
            coverageDiagnostic.uncoveredBranches.length && (
            <p>
                {labels.coverageBranchesRemaining.replace(
                    "{{count}}",
                    String(
                        coverageDiagnostic.uncoveredBranchCount -
                            coverageDiagnostic.uncoveredBranches.length
                    )
                )}
            </p>
        )}
    </>
);

export default WhatsappPreRegistrationCoverageDiagnosticAlert;
